import { render, staticRenderFns } from "./RegistrationBlock.vue?vue&type=template&id=b76878f4"
import script from "./RegistrationBlock.vue?vue&type=script&lang=js"
export * from "./RegistrationBlock.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBlock.vue?vue&type=style&index=0&id=b76878f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports